import { render, staticRenderFns } from "./fankui.vue?vue&type=template&id=4f1cc8bc&scoped=true&"
import script from "./fankui.vue?vue&type=script&lang=js&"
export * from "./fankui.vue?vue&type=script&lang=js&"
import style0 from "./fankui.vue?vue&type=style&index=0&id=4f1cc8bc&lang=scss&scoped=true&"
import style1 from "./fankui.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1cc8bc",
  null
  
)

export default component.exports